export default [
  {
    path: '/solve_center',
    // path: 'https://souche.yuque.com/wireless-solution/open-platform/wwu93m',
    title: '开放版图',
    children: [
      {
        path: 'https://di-open.souche.com',
        title: '数据智能门户',
      }
    ],
  },
  {
    path: '/documents',
    title: '文档中心',
    children: [
      {
        path: '/documents/docking_process',
        title: '服务端接入指南'
      },
      {
        path: '/documents/mobile_process',
        title: '移动应用接入'
      },
      {
        path: '/documents/izayoi_message/message',
        title: '消息文档'
      },
      {
        path: '/documents/other_docs/common/introduce',
        title: '其它方案文档'
      },
      // {
      //   path: '/documents/quick_access',
      //   titile: '快速接入'
      // },
      // {
      //   path: '/documents/api',
      //   title: 'API文档'
      // },
      // {
      //   path: '/documents/common_tool',
      //   title: '常用工具'
      // }
    ]
  },

  {
    path: '/dashboard',
    title: '控制台',
    // children: [
    //   {
    //     path: '/control_plat/app_control',
    //     title: '应用管理'
    //   },
    //   {
    //     path: '/control_plat/debug_toll',
    //     title: 'DEBUG工具'
    //   },
    //   {
    //     path: '/control_plat/sdk_dowload',
    //     title: 'SDK下载'
    //   }
    // ]
  },
  {
    path: '/support_center',
    title: '支持中心',
    children: [
      {
        path: '/support/FAQ',
        title: 'FAQ',
      },
      {
        path: '/support/work_order',
        title: '工单',
      },
    ],
  },
  {
    path: '/notices',
    title: '平台公告',
    // children: [
    //   {
    //     path: '/notice/updated',
    //     title: '更新',
    //   },
    //   {
    //     path: '/notice/message',
    //     title: '通知',
    //   },
    //   {
    //     path: '/notice/big_news',
    //     title: '大事记',
    //   },
    // ],
  }
];
